import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';

import TopFilterLayout from './layouts/top-filter-layout.vue';
import SideFilterLayout from './layouts/side-filter-layout.vue';
import NoFilterLayout from './layouts/no-filter-layout.vue';
import JobDetailsLayout from './layouts/job-details-layout.vue';
import HeroFilterOnlyLayout from './layouts/hero-filter-only-layout.vue';
import ApplyFormLayout from './layouts/apply-form-layout.vue';
import i18n from './i18n';

// register layout variants
Vue.component('no-filter-layout', NoFilterLayout);
Vue.component('top-filter-layout', TopFilterLayout);
Vue.component('side-filter-layout', SideFilterLayout);
Vue.component('job-details-layout', JobDetailsLayout);
Vue.component('hero-filter-only-layout', HeroFilterOnlyLayout);
Vue.component('apply-form-layout', ApplyFormLayout);

import { ValidationProvider, ValidationObserver } from 'vee-validate';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

// register global mixins
import { localizationMixin } from '@/mixins/localization.js';
Vue.mixin(localizationMixin);

Vue.config.productionTip = false;

// Initialize Keycloak once before the app mounts so any login response in the
// URL (after a redirect back) is processed before the router evaluates guards.
// Failures resolve as "anonymous" and never block the portal from loading.
store.dispatch('candidateModule/initAuth').finally(() => {
  new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: (h) => h(App)
  }).$mount('#app');
});
